import { render, staticRenderFns } from "./Indictment.vue?vue&type=template&id=2b334dcf&scoped=true"
import script from "./Indictment.vue?vue&type=script&lang=js"
export * from "./Indictment.vue?vue&type=script&lang=js"
import style0 from "./Indictment.vue?vue&type=style&index=0&id=2b334dcf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b334dcf",
  null
  
)

export default component.exports